import { InviteFlow } from "./registration/InviteFlow";

/** Invite entry at legacy `/user/invite` (mobile Profile WebView). */
export function InviteScreen() {
  return <InviteFlow />;
}
